/* eslint-disable */

document.addEventListener("alpine:init", () => {
  Alpine.data("slideCountry", (props) => {
    let _self;
    let _refs;

    function setCountrySliderListener() {
      const addressTitle = _refs.addressTitle;
      const addressSubtitle = _refs.addressSubtitle;

      const cityPoints = _self.querySelectorAll(".city-point");

      if(cityPoints.length === 1) {
        cityPoints[0].classList.add("selected");
      } else {
        cityPoints.forEach(cityPoint => {
          cityPoint.addEventListener("click", () => {
            cityPoints.forEach(cityPoint => {
              cityPoint.classList.remove("selected");
            });
            cityPoint.classList.add("selected");
            const pathID = cityPoint.dataset.pathid;
            if (props.cities[pathID] && props.cities[pathID].name && props.cities[pathID].address) {
              _refs.addressContainer.classList.remove("md:hidden");
              addressTitle.textContent = props.cities[pathID].name;
              addressSubtitle.innerHTML = props.cities[pathID].address;
            } else {
              addressTitle.textContent = "";
              addressSubtitle.textContent = "";
              _refs.addressContainer.classList.add("md:hidden");
            }
          });
        });
      }
    }

    function getAndDisplayImage() {
      if (props.imgSrc) {
        const imgContainer = _refs.imgContainer;
        fetch(props.imgSrc)
          .then(response => response.text())
          .then(svgContent => {
            imgContainer.innerHTML = svgContent;
          })
          .then(setCountrySliderListener);
      }
    }

    return {
      init() {
        _self = this.$el;
        _refs = this.$refs;
        getAndDisplayImage();
      }
    };

  });
});